export class FeaturedListingsState {
  public isLoading: boolean;
  public items: Array<object>;

  constructor() {
    this.isLoading = false;
    this.items = [];
  }
}
